import React from 'react';

export default function LookupHero({ title, subtitle, meta, actions, image, map, imageAlt = '' }) {
  const hasMap = !!map;
  const hasImage = !!image && !hasMap;
  const hasBackdrop = hasMap || hasImage;

  return (
    <header
      className={[
        'lookup-hero-card',
        hasBackdrop && 'has-backdrop',
        hasMap && 'has-map',
        hasImage && 'has-image',
      ].filter(Boolean).join(' ')}
    >
      {hasMap && (
        <div className="lookup-hero-backdrop lookup-hero-backdrop--map" aria-hidden="true">
          {map}
        </div>
      )}

      {hasImage && (
        <div className="lookup-hero-backdrop lookup-hero-backdrop--image" aria-hidden="true">
          {typeof image === 'string' ? (
            <img src={image} alt={imageAlt || title} className="lookup-hero-backdrop-image" />
          ) : (
            image
          )}
        </div>
      )}

      <div className="lookup-hero-body">
        <h2 className="lookup-hero-entity-title">{title}</h2>
        {subtitle && <p className="lookup-hero-entity-subtitle">{subtitle}</p>}
        {meta && <div className="lookup-hero-entity-meta">{meta}</div>}
        {actions && <div className="lookup-hero-entity-actions">{actions}</div>}
      </div>
    </header>
  );
}
